'use strict';

angular.module('propertyDetailController', [])

.controller('PropertyDetailController', ['$scope', '$rootScope', '$log', '$location', '$window','AgencyService', 'BuyerService', 'CommonService',
    function ($scope, $rootScope, $log, $location, $window, AgencyService, BuyerService, CommonService) {    
    
    $scope.preferedProperties = [];
    $scope.watchlist = [];
    //  $scope.activeAgency = $rootScope.currentUser.activeAgency;
    $rootScope.header.show = false;
   
    var loadProperties = function() {
        var upstreamCall = true;
        if(!$rootScope.loading) {
            $rootScope.loading = true;
            upstreamCall = false;
        }
        BuyerService.getPreferences()
        .then(function(data) {
            var preferences = data[0];
            var suburbs = JSON.parse(preferences.suburbs);
            var propertyTypes = JSON.parse(preferences.propertyTypes);

            preferences.suburbs = suburbs;
            preferences.propertyTypes = propertyTypes;  

            return BuyerService.getPreferedProperties(preferences);
        })
        .then(function(data){
            $scope.preferedProperties = data;
            return BuyerService.getWatchlist();
        })
        .then(function(data){
            $scope.watchlist = data;
            angular.forEach($scope.preferedProperties, function(property){
                var index = CommonService.indexByField($scope.watchlist, 'propertyId', property.propertyId);
                if(index > 0) {
                    property.watched = true;
                    property.watchlistId = $scope.watchlist[index].id;
                } else {
                    property.watched = false;
                    property.watchlistId = 0;
                }
            });
        })
        .catch(function(err) {
            console.log(err);
        })
        .finally(function(data) {
            // loadPreferences();
            if (!upstreamCall) {
                $rootScope.loading = false;
            }
            
        });

        //load preferences from db
      
    }

    var init = function() {
        loadProperties();
    }

    $scope.addToWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.addToWatchlist(property.propertyId)
        .then(function(data){
            // property.watched = true;
            loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    $scope.removeFromWatchlist = function(property) {
        $rootScope.loading = true;
        BuyerService.removeFromWatchlist(property.watchlistId)
        .then(function(data){
            // property.watched = false;
            // property.watchlistId = false;
            loadProperties();
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        })
    }

    init();

}]);